import { absences } from '@markku/db'
import { createInsertSchema, createSelectSchema } from 'drizzle-zod'
import { z } from 'zod'
import { withAttachments } from './attachment'

export const selectAbsenceSchema = createSelectSchema(absences, {
  // Internal field is auto-filtered for non-privileged users; allow undefined.
  internalNotes: z.string().nullable().optional(),
})

export const selectAbsenceWithUserSchema = selectAbsenceSchema.extend({
  user: z
    .object({
      id: z.number(),
      firstName: z.string(),
      lastName: z.string(),
      email: z.string(),
    })
    .optional(),
  approvedByUser: z
    .object({
      id: z.number(),
      firstName: z.string(),
      lastName: z.string(),
    })
    .nullable()
    .optional(),
})

export const selectAbsenceWithRelationsSchema = withAttachments(
  selectAbsenceWithUserSchema,
)

// Privileged staff (officer/admin) pick the employee via userId; for self-service
// it is auto-filled from auth context, so it stays optional here. status/approval
// fields are admin-only and enforced server-side.
export const upsertAbsenceSchema = createInsertSchema(absences)
  .omit({
    id: true,
    createdAt: true,
    updatedAt: true,
    deletedAt: true,
  })
  .partial({ userId: true })

export type Absence = z.infer<typeof selectAbsenceSchema>
export type AbsenceWithUser = z.infer<typeof selectAbsenceWithUserSchema>
export type AbsenceWithRelations = z.infer<
  typeof selectAbsenceWithRelationsSchema
>
export type UpsertAbsence = z.infer<typeof upsertAbsenceSchema>
